module.exports = __webpack_public_path__ + "img/spider_egg_clutch_small.95767797.png";